// Wichita State University's undergraduate majors (#2839). Read on
// 2026-10-01 from the official 2026-2027 Undergraduate Catalog's
// "Undergraduate Degrees and Academic Majors" table
// (catalog.wichita.edu/undergraduate/degrees-academic-majors/), which lists
// each program with its type, department and college. Every bachelor's row
// is kept as the catalog names it, emphases and concentrations included
// (BA, BS, BAED, BBA, BFA, BM, BME, BAA, BAS, BSN, BSW, BGS, the Honors
// Baccalaureate and the Fairmount College field majors, whose type the
// catalog gives as "Field Major"); the catch-all "Field Major" row, minors,
// field minors, certificates, the AA and AS, and the accelerated bachelor's
// to master's rows are left out. Biochemistry appears twice in the catalog
// (field major in two departments) and once here, with a note. Degree
// abbreviations and college names are the catalog's own; "Biological/
// Biomedical" style names lose the line-break space after the slash. The
// College of Innovation and Design lists no bachelor's program here.
const majors = {
    "slug": "wichita-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Wichita State's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to, as the catalog lists them (emphases and concentrations included). Minors, certificates, associate degrees, accelerated bachelor's to master's programs and graduate programs are left out.",
    "groups": [
        {
            "name": "Fairmount College of Liberal Arts and Sciences",
            "source": {
                "label": "WSU 2026-2027 Undergraduate Catalog, Undergraduate Degrees and Academic Majors",
                "url": "https://catalog.wichita.edu/undergraduate/degrees-academic-majors/"
            },
            "majors": [
                {
                    "name": "American Sign Language",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Field Major",
                    "note": "Offered through both Biological Sciences and Chemistry and Biochemistry."
                },
                {
                    "name": "Biological Sciences with Biological/Biomedical Emphasis",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences with Biological/Biomedical Emphasis",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences with Ecological/Environmental/Organismal Emphasis",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences with Ecological/Environmental/Organismal Emphasis",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry - Biochemistry Option",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry - Chemistry Option",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry - Premedicine",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry - Business",
                    "degree": "Field Major"
                },
                {
                    "name": "Communication - Communication Studies Emphasis",
                    "degree": "BA"
                },
                {
                    "name": "Communication - Departmental Honors Track",
                    "degree": "BA"
                },
                {
                    "name": "Communication - Integrated Marketing Communication Emphasis",
                    "degree": "BA"
                },
                {
                    "name": "Communication - Journalism and Media Production Emphasis",
                    "degree": "BA"
                },
                {
                    "name": "Communication - Open Emphasis",
                    "degree": "BA"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice - Courts and Law",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice - Criminal Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "General Studies",
                    "degree": "BGS"
                },
                {
                    "name": "Geology",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Homeland Security",
                    "degree": "BS"
                },
                {
                    "name": "International Studies - Area Studies",
                    "degree": "Field Major"
                },
                {
                    "name": "International Studies - Business Administration",
                    "degree": "Field Major"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics - Computing Emphasis",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics - Data Science Emphasis",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics - Statistics Emphasis",
                    "degree": "BS"
                },
                {
                    "name": "Modern and Classical Languages and Literatures - Bilingual Option",
                    "degree": "BA"
                },
                {
                    "name": "Modern and Classical Languages and Literatures - French Specialization",
                    "degree": "BA"
                },
                {
                    "name": "Modern and Classical Languages and Literatures - Latin Specialization",
                    "degree": "BA"
                },
                {
                    "name": "Modern and Classical Languages and Literatures - Spanish Specialization",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy - Pre-Law",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Women's, Ethnicity and Intersectional Studies",
                    "degree": "Field Major"
                }
            ]
        },
        {
            "name": "W. Frank Barton School of Business",
            "source": {
                "label": "WSU 2026-2027 Undergraduate Catalog, Undergraduate Degrees and Academic Majors",
                "url": "https://catalog.wichita.edu/undergraduate/degrees-academic-majors/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Administration",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Economics Emphasis in Real Estate",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Entrepreneurship Emphasis in Real Estate",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Finance Emphasis in Real Estate",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Hospitality",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Human Resource Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Information Technology and Management Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - International Business",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Marketing Emphasis in Digital Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration - Marketing Emphasis in Real Estate",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "WSU 2026-2027 Undergraduate Catalog, Undergraduate Degrees and Academic Majors",
                "url": "https://catalog.wichita.edu/undergraduate/degrees-academic-majors/"
            },
            "majors": [
                {
                    "name": "Education - Biology (Secondary)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Chemistry (Secondary)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Early Childhood Unified",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Early Childhood Unified/Elementary Education Apprentice",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Earth and Space Science (Secondary)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Elementary",
                    "degree": "BAED"
                },
                {
                    "name": "Education - English/Language Arts (Secondary)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - English/Science (Middle)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - French (PreK-12)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - History, Government and Social Studies (Secondary)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - History/English (Middle)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - History/Mathematics (Middle)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - History/Science (Middle)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Mathematics (Middle)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Mathematics (Secondary)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Mathematics/English (Middle)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Mathematics/Science (Middle)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Physical Education (PreK-12)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Physics (Secondary)",
                    "degree": "BAED"
                },
                {
                    "name": "Education - Spanish (PreK-12)",
                    "degree": "BAED"
                },
                {
                    "name": "Organizational Leadership and Learning",
                    "degree": "BAS"
                },
                {
                    "name": "Sport Management",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "WSU 2026-2027 Undergraduate Catalog, Undergraduate Degrees and Academic Majors",
                "url": "https://catalog.wichita.edu/undergraduate/degrees-academic-majors/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Applied Engineering - Engineering Management Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Applied Engineering - Process Automation Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Applied Engineering - Sustainability and Environmental Engineering Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Product Design and Manufacturing Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "WSU 2026-2027 Undergraduate Catalog, Undergraduate Degrees and Academic Majors",
                "url": "https://catalog.wichita.edu/undergraduate/degrees-academic-majors/"
            },
            "majors": [
                {
                    "name": "Art Education Emphasis PK-12",
                    "degree": "BFA"
                },
                {
                    "name": "Art - Art Emphasis",
                    "degree": "BA"
                },
                {
                    "name": "Art - Art History Emphasis",
                    "degree": "BA"
                },
                {
                    "name": "Art - Studio Art - Applied Drawing Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art - Studio Art - Ceramics Media Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art - Studio Art - Community and Social Practices Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art - Studio Art - Painting Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art - Studio Art - Photo Media Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art - Studio Art - Print Media Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art - Studio Art - Sculpture Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Composition - Harp/Guitar/Bass",
                    "degree": "BM"
                },
                {
                    "name": "Composition - Keyboard",
                    "degree": "BM"
                },
                {
                    "name": "Composition - Strings",
                    "degree": "BM"
                },
                {
                    "name": "Composition - Vocal",
                    "degree": "BM"
                },
                {
                    "name": "Composition - Winds/Percussion",
                    "degree": "BM"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Media Arts - Acting for Digital Arts Concentration",
                    "degree": "BAA"
                },
                {
                    "name": "Media Arts - Animation Concentration",
                    "degree": "BAA"
                },
                {
                    "name": "Media Arts - Audio Production Concentration",
                    "degree": "BAA"
                },
                {
                    "name": "Media Arts - Collaborative Design Concentration",
                    "degree": "BAA"
                },
                {
                    "name": "Media Arts - Filmmaking Concentration",
                    "degree": "BAA"
                },
                {
                    "name": "Media Arts - Game Design Concentration",
                    "degree": "BAA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music - Music Industry Studies Emphasis",
                    "degree": "BA"
                },
                {
                    "name": "Music Education - Instrumental",
                    "degree": "BME"
                },
                {
                    "name": "Music Education - Keyboard",
                    "degree": "BME"
                },
                {
                    "name": "Music Education - Vocal",
                    "degree": "BME"
                },
                {
                    "name": "Music Performance - Commercial Music Emphasis",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance - Instrumental Emphasis",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance - Jazz Studies Emphasis",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance - Keyboard Emphasis",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance - Vocal Emphasis",
                    "degree": "BM"
                },
                {
                    "name": "Performing Arts - Acting",
                    "degree": "BFA"
                },
                {
                    "name": "Performing Arts - Dance",
                    "degree": "BA"
                },
                {
                    "name": "Performing Arts - Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Performing Arts - Design and Technical Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Performing Arts - Musical Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Performing Arts - Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Special Music Education",
                    "degree": "BME"
                }
            ]
        },
        {
            "name": "College of Health Professions",
            "source": {
                "label": "WSU 2026-2027 Undergraduate Catalog, Undergraduate Degrees and Academic Majors",
                "url": "https://catalog.wichita.edu/undergraduate/degrees-academic-majors/"
            },
            "majors": [
                {
                    "name": "Aging Studies",
                    "degree": "Field Major/BGS"
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BA"
                },
                {
                    "name": "Dental Hygiene - Degree Completion",
                    "degree": "BS"
                },
                {
                    "name": "Dental Hygiene - Entry Level Program",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science - Concentration in Strength and Conditioning",
                    "degree": "BS"
                },
                {
                    "name": "Health Management",
                    "degree": "BS"
                },
                {
                    "name": "Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Nursing - RN to BSN",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing - Traditional Program",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Dorothy and Bill Cohen Honors College",
            "source": {
                "label": "WSU 2026-2027 Undergraduate Catalog, Undergraduate Degrees and Academic Majors",
                "url": "https://catalog.wichita.edu/undergraduate/degrees-academic-majors/"
            },
            "majors": [
                {
                    "name": "Honors Baccalaureate",
                    "degree": "HB"
                }
            ]
        }
    ]
};

export default majors;
